import React, { useEffect, useState } from "react"
import { useDebounce, useDebouncedCallback } from "use-debounce"

interface TextFilterProps {
  text: string
  onTextChange: (text: string) => void
}

export const TextFilter: React.FC<TextFilterProps> = ({ text, onTextChange }) => {
  const [internalText, setInternalText] = useState(text)
  const [debouncedText] = useDebounce(internalText, 5000)
  const debounced = useDebouncedCallback(
    // function
    value => {
      onTextChange(value)
    },
    // delay in ms
    1000,
  )
  useEffect(() => {
    //onTextChange(debouncedText)
  }, [debouncedText, onTextChange])

  // Sync internal state when external filter value changes (e.g. set by clicking phone number)
  useEffect(() => {
    setInternalText(text)
  }, [text])

  return (
    <div className="form-control flex flex-1 flex-col">
      <label className="label">
        <span className="label-text">Текст</span>
      </label>
      <input
        type="text"
        className="input input-bordered"
        value={internalText}
        onChange={e => {
          setInternalText(e.target.value)
          debounced(e.target.value)
        }}
      />
    </div>
  )
}
